import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Load order matters: fonts.css declares CSS vars consumed by theme.css.
import "./fonts.css";
import "./theme.css";

import { App } from "./App";
import { applyTheme, getStoredTheme } from "./theme";

// Apply the stored theme before first paint so there's no light-mode flash
// for dark-mode users.
applyTheme(getStoredTheme());

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
